
import { Component } from 'react';
import http from "../services/http-common";
import { resolveMenu } from './menuChannel';
const querystring = require('querystring');

class ApiDataService extends Component {
  // channelId lets a component ask for a specific menu's channel_id instead
  // of the ambient one auto-resolved from window.location.pathname. Needed
  // when a component (e.g. FileManager) is embedded inside another page's
  // route (e.g. /image-optimize) — without it, the request would carry the
  // HOST page's channel_id instead of its own, and the backend's menu
  // authorization check (which matches channel_id's registered definition
  // against the request URL) rejects it with a 402.
  getAll(path, param, lang = "", channelId = null) {
    return http.get(`${path}${param}`, this.setUpConfiguartion(lang, channelId));
  }
  get(path, lang, channelId = null) {
    return http.get(`${path}`, this.setUpConfiguartion(lang, channelId));
  }
  post(path, data, lang = false, extraConfig = {}, channelId = null) {
    let config = this.setUpConfiguartion(lang, channelId);
    // Merge extraConfig (e.g. headers) into the generated config
    const finalConfig = { ...config, ...extraConfig };
    if (extraConfig.headers) {
      finalConfig.headers = { ...config.headers, ...extraConfig.headers };
    }
    return http.post(path, data, finalConfig);
  }
  update(path, data, lang = false, extraConfig = {}) {
    let config = this.setUpConfiguartion(lang);
    const finalConfig = { ...config, ...extraConfig };
    if (extraConfig.headers) {
      finalConfig.headers = { ...config.headers, ...extraConfig.headers };
    }
    return http.post(`${path}`, data, finalConfig);
  }
  delete(path, id, params) {
    let browserData = localStorage.getItem('USER_INFO');
    let jsonAccess = JSON.parse(browserData);
    let authToken = localStorage.getItem('AUTH_TOKEN');
    let menu = resolveMenu(window.location.pathname);
    let menucode = (params && params.channel_id) ? params.channel_id : (menu ? menu.menucode : '');
    let langCode = (params && params.lang_code) ? params.lang_code : jsonAccess.lang_code;
    let commonParam = {
      lang_code: langCode,
      logged_user_id: jsonAccess.user_id,
      logged_site_id: jsonAccess.site_id,
      channel_id: menucode,
      auth_token: authToken
    };

    return http.delete(`${path}${id}?channel_id=${menucode}&lang_code=${langCode}`, { data: querystring.stringify(commonParam) });
  }

  deleteWithBody(path, data) {
    let menu = resolveMenu(window.location.pathname);
    let menucode = menu ? menu.menucode : '';
    return http.delete(`${path}?channel_id=${menucode}`, { data });
  }

  setUpConfiguartion(paramlang = null, channelIdOverride = null) {
    let browserData = localStorage.getItem('USER_INFO');
    let jsonAccess = JSON.parse(browserData);
    var defaultLanguage = (paramlang ? paramlang : (jsonAccess ? jsonAccess.lang_code : ''));
    if (channelIdOverride) {
      return { params: { channel_id: channelIdOverride, lang_code: defaultLanguage } };
    }
    // Resolve channel_id for the current page from the cached menu tree, so the
    // request carries it even without a prior menu click (refresh / direct URL).
    let menu = resolveMenu(window.location.pathname);
    if (menu && menu.menucode) {
      return { params: { channel_id: menu.menucode, lang_code: defaultLanguage } };
    }
    return { params: { lang_code: defaultLanguage } };
  }
}

export default new ApiDataService();
